import  { dataInitialApprovalHighAccident, dataInitialCloneHighAccident } from './state'

/**
 * Mutación para cargar las empresas al store de la aplicación.
 */
export function setCompanies(state, companies) {
    state.companies = companies;
}

/**
 * Mutación para limpiar el filto de compañias.
 */
export function resetValues(state) {
    state.companies = [];
    (state.companies = []),
        (state.filter.company.id = null),
        (state.filter.company.nombre = null),
        (state.filter.page = 1);
    state.filter.perPage = 10;
    state.filter.sortBy = "id";
    (state.filter.location_id = null),
        (state.filter.sort = "DESC"),
        (state.filter.search = "");
    state.accidents_high = [];
    state.filter.is_approved = 'all';
}

/**
 * Mutación para sesetear el filtro de productos.
 * @param {*} state
 */
export function resetFilterProducts(state) {
    state.filterProducts.location_id = null;
    state.filterProducts.page = 1;
    state.filterProducts.perPage = 10;
    state.filterProducts.search = "";
}

/**
 * Mutación resetear el estate de newAccident.
 *
 * @param {*} state
 * @author Luis Almendrales
 */
export function resetNewRegister(state) {
    (state.modalCreate.view = false),
        (state.newAccident.id = null),
        (state.newAccident.start_date = "");
    state.newAccident.slq_location_id = null;
    state.newAccident.description = "";
    state.newAccident.company_id = null;
    state.newAccident.active = true;
}

/**
 * Mutación para cargar los accidentes mayores.
 *
 * @param {*} state
 * @author Luis Almendrales
 */
export function setAccidentHigh(state, accidents_high) {
    state.accidents_high = accidents_high;
}

/**
 * Mutación para cargar las ubicaciones de la compañia.
 *
 * @param {*} state
 * @param {*} locations
 * @author Luis Almendrales
 */
export function setLocations(state, locations) {
    state.locations = locations;
}

/**
 * Mutación para mostrar el modal de crear.
 *
 * @param {*} state
 * @param {*} view
 * @author Luis Almendrales
 */
export function setModalCreate(state, view) {
    state.modalCreate.view = view;
}

/**
 * Mutación para mostrar el modal de crear producto.
 *
 * @param {*} state
 * @param {*} view
 * @author Luis Almendrales
 */
export function setModalCreateNewProduct(state, view) {
    state.modalCreatedProduct.view = view;
}

/**
 * Mutación para setear un accidente mayor.
 *
 * @param {*} state
 * @param {*} accident_high
 * @author Luis Almendrales
 */
export function setAccidentHighById(state, accident_high) {
    state.newAccident = accident_high;
}

/**
 * Mutación para setear los productos de la ubicacion.
 *
 * @param {*} state
 * @param {*} products
 * @author Luis Almendrales
 */
export function setProducts(state, products) {
    state.productsByLocation = products;
}

/**
 * Setear los productos asociados a un accidente mayor.
 *
 * @param {*} state
 * @param {*} products
 */
export function setProductsAccident(state, products) {
    state.productsByAccident = products;
}

/**
 * Mutación para setear los productos de la ubicacion no ppam.
 *
 * @param {*} state
 * @param {*} products
 * @author Luis Almendrales
 */
export function setProductsNotPpam(state, products) {
    state.productsNotPpamByLocation = products;
}

/**
 * Mutación para setear los productos de la ubicacion inactivos ppam.
 *
 * @param {*} state
 * @param {*} products
 * @author Luis Almendrales
 */
export function setProductsInactivePpam(state, products) {
    state.productsByInactiveLocation = products;
}

/**
 * Mutación para setear las unidades de medida.
 *
 * @param {*} state
 * @param {*} units
 * @author Luis Almendrales
 */
export function setUnitMeasures(state, unitMeasures) {
    state.unitMeasures = unitMeasures;
}

/**
 * Mutación para setear las unidades de densidad.
 *
 * @param {*} state
 * @param {*} units
 * @author Luis Almendrales
 */
export function setDensityUnits(state, densityUnits) {
    state.densityUnits = densityUnits;
}

/**
 * Mutación para setear la ubicacion.
 *
 * @param {*} state
 * @param {*} location
 * @author Luis Almendrales
 */
export function setLocation(state, location) {
    state.location = location;
}

/**
 * Establecer datos de prodcuto seleccionada.
 *
 * @param {*} state
 * @param {*} product
 * @param {*} index
 * @author Luis Almendrales
 */
export function setProductSelected(state, {product, key}) {
    let unitDensity = null;
    let ton_weight = 0;

    if (
        product.item.high_accident_product &&
        product.item.high_accident_product.mesure_unit_id == 188
    ) {
        unitDensity = null;
        product.item.high_accident_product.density = null;
        ton_weight = product.item.high_accident_product.quantity / 1000;
    }
    if (
        product.item.high_accident_product &&
        product.item.high_accident_product.mesure_unit_id == 189
    ) {
        unitDensity = null;
        product.item.high_accident_product.density = null;
        ton_weight = product.item.high_accident_product.quantity / 2000;
    }
    if (
        product.item.high_accident_product &&
        product.item.high_accident_product.mesure_unit_id == 192
    ) {
        unitDensity = null;
        product.item.high_accident_product.density = null;
        ton_weight = product.item.high_accident_product.quantity / 1e6;
    }

    if (
        product.item.high_accident_product &&
        product.item.high_accident_product.mesure_unit_id === 191
    ) {
        unitDensity = 197;
        ton_weight =
            (product.item.high_accident_product.density *
                product.item.high_accident_product.quantity *
                1) /
            1000;
    } else if (
        product.item.high_accident_product &&
        product.item.high_accident_product.mesure_unit_id === 190
    ) {
        unitDensity = 196;
        ton_weight =
            (product.item.high_accident_product.density *
                product.item.high_accident_product.quantity *
                0.001) /
            1000;
    } else if (
        product.item.high_accident_product &&
        product.item.high_accident_product.mesure_unit_id === 902
    ) {
        unitDensity = 196;
        let l = product.item.high_accident_product.quantity * 3.78;
        ton_weight =
            (product.item.high_accident_product.density * l * 0.001) / 1000;
    } else if (
        product.item.high_accident_product &&
        product.item.high_accident_product.mesure_unit_id === 193
    ) {
        unitDensity = 194;
        let l = product.item.high_accident_product.quantity;
        ton_weight = (product.item.high_accident_product.density * l) / 1000000;
    } else if (
        product.item.high_accident_product &&
        product.item.high_accident_product.mesure_unit_id === 256
    ) {
        unitDensity = 253;
        let l = product.item.high_accident_product.quantity * 3.78541178;
        ton_weight =
            (product.item.high_accident_product.density * l * 0.001) / 1000;
    }
    else if (
        product.item.high_accident_product &&
        product.item.high_accident_product.mesure_unit_id === 1173
    ) {
        unitDensity = 197;
        let resultBarrtoM3 = product.item.high_accident_product.quantity * 0.15899;
        ton_weight = (product.item.high_accident_product.density * resultBarrtoM3) / 1000;
    }


    state[key].data[product.index].high_accident_product = {
        slq_high_accident_id: state.accidentHighId,
        product_id: product.item.id_producto,
        quantity: product.item.high_accident_product
            ? product.item.high_accident_product.quantity
            : null,
        mesure_unit_id: product.item.high_accident_product
            ? product.item.high_accident_product.mesure_unit_id
            : null,
        density: product.item.high_accident_product
            ? product.item.high_accident_product.density
            : null,
        density_unit_id: unitDensity,
        ton_weight: getTonWeightAttribute(ton_weight),
        company_id: product.item.id_empresa,
        active: true,
        special_conditions: product.item.high_accident_product
            ? product.item.high_accident_product.special_conditions
            : 0,
        storage_temperature: product.item.high_accident_product
            ? product.item.high_accident_product.storage_temperature
            : null,
    };
}

/**
 * Get the ton_weight attribute and convert to scientific notation if more than 3 decimal places.
 *
 * @param  float  $value
 * @return string
 */
export function getTonWeightAttribute(value) {
    // Convert to scientific notation if more than 3 decimal places
    const decimalPart = Math.floor(value) === value ? 0 : value.toString().length - value.toString().lastIndexOf('.') - 1;
    if (decimalPart > 3) {
        return value.toExponential(3);
    }

    return value.toString();
}

/**
 * Mutación para setear el id de un accidente mayor.
 *
 * @param {*} state
 * @param {*} id
 * @param {*} index
 * @author Luis Almendrales
 */
export function setAccidentHighId(state, id) {
    state.accidentHighId = id;
}

/**
 * Mutación para setear el resumen de un accidente mayor.
 * @param {*} state
 * @param {*} summary
 * @author Luis Almendrales
 */
export function setSummary(state, summary) {
    state.summary = summary;
}

/**
 * Mutación para setear el id del fabricante en el filtro de productos.
 *
 * @param {*} state
 * @param {*} data
 */
export function setProducers(state, data) {
    state.producers = data;
}

/**
 * Mutación para setear el la empresa.
 *
 * @param {*} state
 * @param {*} data
 */
export function setCompany(state, data) {
    state.filter.company = data;
}

/**
 * Mutación para mostrar el modal de asignacion de productos.
 *
 * @param {*} state
 * @param {*} view
 * @author Luis Almendrales
 */
export function setModalAsigne(state, data) {
    state.modalAsigne.view = data;
}

/**
 * Mutación setear los productos no asigandos a la empresa
 *
 * @param {*} state
 * @param {*} view
 * @author Luis Almendrales
 */
export function setProductsNoAsigne(state, data) {
    state.productsNoAsigned = data;
}

/**
 * Mutacion para limpiar los productos no asignados y el filterProductsNoAsigned.id
 *
 * @param {*} state
 */
export function clearProductsNoAsigne(state) {
    state.productsNoAsigned = [];
    state.filterProductsNoAsigned.id = null;
}

/**
 * Mutación para resetear newAdjuntToProduct.
 * @param {*} state
 * @author Luis Almendrales
 */
export function resetNewAdjuntToProduct(state) {
    state.newAdjuntToProduct = {
        tipo: "",
        fecha: null,
        sistema: "no",
        activo: 1,
        cumple_decreto: "",
        no_cumple: 0,
        observacion_no_cumple: "",
        idioma: "",
        observacion: "",
        estado_fds: "",
    };
}

/**
 * Restablecer datos de aprobación del accidente mayor.
 *
 * @param Object state
 */
export function resetModalApprovalHighAccident(state) {
    state.modalApprovalHighAccident = dataInitialApprovalHighAccident()
}


/**
 * Establecer datos de aprobación del accidente mayor.
 *
 * @param Object state
 * @param Object nextState
 */
export function setModalApprovalHighAccident(state, nextState) {
    state.modalApprovalHighAccident = nextState
}

/**
 * Restablecer detalles de la aprobación del accidente mayor.
 *
 * @param Object state
 */
export function resetModalDetailsApproveHighAccident(state) {
    state.modalDetailsApproveHighAccident = dataInitialApprovalHighAccident()
}


/**
 * Establecer detalles de la aprobación del accidente mayor.
 *
 * @param Object state
 * @param Object nextState
 */
export function setModalDetailsApproveHighAccident(state, nextState) {
    state.modalDetailsApproveHighAccident = nextState
}

/**
 * Establecer datos del accidente mayor.
 *
 * @param Object state
 * @param Object nextState
 */
export function setHighAccident(state, nextState) {
    state.highAccident = nextState
}

/**
 * Restablecer datos para clonar el accidente mayor.
 *
 * @param Object state
 */
export function resetModalCloneHighAccident(state) {
    state.modalCloneHighAccident = dataInitialCloneHighAccident()
}

/**
 * Establecer datos para clonar el accidente mayor.
 *
 * @param Object state
 * @param Object nextState
 */
export function setModalCloneHighAccident(state, nextState) {
    state.modalCloneHighAccident = nextState
}



/**
 * Mostrar u ocultar modal de comparación de productos de un accidente mayor.
 *
 * @param bool show
 */
export function showModalProductsComparative(state, show) {
    state.modalProductsComparative = show;
}


/**
 * Setear información de tabla comparativa
 *
 * @param bool show
 */
export function setListComparative(state, list_comparative) {
    Object.keys(list_comparative).forEach(key =>  {
        state.list_comparative[key] = list_comparative[key]
    })
}
